export const PaymentBlockedMissingApproverReason = {
    APPROVAL_LEVEL_NO_REQUIRED_APPROVER: 'approval_level_no_required_approvers',
    NO_MANUAL_APPROVER: 'no_manual_approver',
};
export const paymentBlockedReasonText = {
    [PaymentBlockedMissingApproverReason.APPROVAL_LEVEL_NO_REQUIRED_APPROVER]: "by an approval level that's missing a required approver",
    [PaymentBlockedMissingApproverReason.NO_MANUAL_APPROVER]: 'because a manually added approver is no longer active',
};
